import { FC } from 'react';

import { getPurpurIcon } from '@telialt/common-icon/src/utils';
import { NavigationItem } from '@telialt/models/src/Navigation';
import { usePathname } from '@telialt/utils/src/pathname';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { getIsContactsAndPrivacyPath, getIsMyAccountPath } from '../../utils/path';
import { MenuItemIcon, StyledMenuItem } from '../MenuItem/MenuItem.styles';

type Props = { item: NavigationItem };

export const MenuItemSegmentLink: FC<Props> = ({ item }) => {
    const { title, url, colorOption, displayOption, icon, component } = item;
    const purpurIcon = getPurpurIcon(icon);
    const segment = useSegment();
    const currentPath = usePathname();

    const isNotMyAccountNorContactsAndPrivacyPath =
        !getIsMyAccountPath(currentPath) && !getIsContactsAndPrivacyPath(currentPath);

    const isActiveB2xLink =
        (component === 'SEGMENT_B2C' && segment === TeliaSegment.B2c) ||
        (component === 'SEGMENT_B2B' && segment === TeliaSegment.B2b);

    const isActiveSsLink = component === 'SS_SEGMENT_LINK' && currentPath.startsWith(url);

    const isActive = isNotMyAccountNorContactsAndPrivacyPath && (isActiveB2xLink || isActiveSsLink);

    return (
        <StyledMenuItem
            $isActive={isActive}
            aria-current={isActive ? 'location' : undefined}
            $displayOption={displayOption}
            $colorOption={colorOption}
            href={url}
        >
            {title}
            {purpurIcon && <MenuItemIcon svg={purpurIcon} size="sm" />}
        </StyledMenuItem>
    );
};
